import React from 'react';
import {
  Box, Container, Typography, makeStyles,
} from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import MonthlyReportPanel from './MonthlyReportPanel';
import DatesReportPanel from './DatesReportPanel';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

export default function ContabilidadView() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Mi Contabilidad">
      <Container maxWidth={false}>
        <Box mb={2}>
          <Typography variant="h3" color="textSecondary">
            Mi Contabilidad
          </Typography>
        </Box>
        <MonthlyReportPanel />
        <DatesReportPanel />
      </Container>
    </Page>
  );
}
